import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'
import './assets/css/index.css';



const rootElement = document.getElementById('root');
rootElement.classList.add('gradient-background')

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

